import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import OnlineCourse from "../components/OnlineCourse";
import NewDriver from "../components/NewDriver";
import DrivingLesson from "../components/DrivingLesson";
import PageLoading from "../components/PageLoading";

import * as API from "../api/api.js";

const LayoutTwo = ({ slug, settings }) => {
  const [loading, setLoading] = useState(false);
  const [drivers, setDrivers] = useState(null);
  const [lesson, setLessonData] = useState(null);
  const [attachment, setAttachment] = useState(null);

  useEffect(() => {
    setNewDriverDatas();
  }, [slug]);

  const setNewDriverDatas = () => {
    setLoading(true);
    API.getDatas(`/page?slug=${slug}`)
      .then((res) => {
        setDrivers(res.data);
        setLessonData(res.data.lessons);
        setAttachment(res.data.attachments);
        setLoading(false);
        document.title = `Metro Traffic School - ${res.data.name}`;
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <>
      <section className="inner-page notranslate d-flex align-items-center justify-content-center">
        <div className="overlay"></div>
        <div className="container">
          {!loading && drivers && (
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xl-12">
                <nav aria-label="breadcrumb">
                  <h4 className="main-heading text-capitalize text-center mb-0">
                    {drivers.name}
                  </h4>
                  <ol className="breadcrumb d-flex align-items-center justify-content-center">
                    <li className="breadcrumb-item">
                      {/* <a  className="text-white">
                      Home
                    </a> */}
                      <Link to={"/"} className="text-white">
                        Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {drivers.name}
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          )}
        </div>
      </section>

      {!loading && slug === "new-drivers" && (
        <OnlineCourse onlineData={drivers} lesson={lesson} />
      )}

      {!loading && slug == "new-drivers/driving-lessons" && (
        <section className="location-section section-padding driving-lesson">
          <div className="container">
            <div className="row">
              <DrivingLesson
                loading={loading}
                information={drivers}
                lesson={lesson}
                settings={settings}
              />
            </div>
          </div>
        </section>
      )}

      {!loading && attachment && (
        <NewDriver courseDetail={drivers} attachment={attachment} />
      )}

      {loading && (
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <PageLoading color={"var(--metro-yellow)"} classes={"justify-content-center"} />
          </div>
        </div>
      )}
    </>
  );
};

export default LayoutTwo;
